import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { FIND_ALL_INSTITUTIONAL_CODES } from 'queries/institutionalCodes'
import {
  FindAllInstitutionalCodes,
  FindAllInstitutionalCodesVariables,
} from '__generatedTypes__/FindAllInstitutionalCodes'
import { SearchTypeEnum } from '__generatedTypes__/globalTypes'

export type InstitutionalCodeFilters = {
  platform?: { id: string }
}

export function castParams({
  page,
  take,
  search,
  order,
  filters,
}: Params<InstitutionalCodeFilters>): FindAllInstitutionalCodesVariables {
  return {
    query: {
      skip: (page - 1) * take,
      take,
      search: search ? { query: search, type: SearchTypeEnum.ILike } : undefined,
      order: order?.field ? { [order.field]: order.direction } : undefined,
      where: filters.platform ? { platform: filters.platform } : undefined,
    },
  }
}

export function useFindAllInstitutionalCodesQuery() {
  return useQueryWithParams<
    FindAllInstitutionalCodes,
    FindAllInstitutionalCodesVariables,
    'findAllInstitutionalCodes',
    'items',
    'count',
    InstitutionalCodeFilters
  >(FIND_ALL_INSTITUTIONAL_CODES, 'findAllInstitutionalCodes', 'items', 'count', castParams)
}
